import Vuex from 'vuex'
import Vue from 'vue'
import axios from 'axios'

Vue.use(Vuex)

const sessionStore = new Vuex.Store({
  state: {
    token: window.localStorage.getItem('collectomate_token'),
    user: null,
    oktaUser: null,
    oktaAuth: false,
    currentlyFetching: false,
    oktaFetching: false,
  },
  mutations: {
    setData(state, newToken) {
      if (newToken && newToken.length) {
        window.localStorage.setItem('collectomate_token', newToken)
        axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`
        newToken
      } else {
        window.localStorage.removeItem('collectomate_token')
        axios.defaults.headers.common['Authorization'] = ''
        state.user = null
        newToken
      }
      state.token = newToken
    },
    setUser(state, user) {
      state.user = user
    },
    setOktaUser(state, user) {
      state.oktaUser = user
    },
    setOktaAuth(state) {
      state.oktaAuth = true
    },
    currentlyFetching(state, currentlyFetching) {
      state.currentlyFetching = currentlyFetching
    },
    oktaFetching(state, oktaFetching) {
      state.oktaFetching = oktaFetching
    },
  },
  getters: {
    token: function (state) {
      return state.token
    },
    user: function (state) {
      return state.user
    },
    oktaUser: function (state) {
      return state.oktaUser
    },
    oktaAuth: function (state) {
      return state.oktaAuth
    },
    currentlyFetching: function (state) {
      return state.currentlyFetching
    },
    oktaFetching: function (state) {
      return state.oktaFetching
    },
  },
})

export default sessionStore
